var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2095_4388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2095_4388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4163 14.154C20.831 14.154 21.1816 14.0088 21.468 13.7183C21.7542 13.4279 21.8973 13.0753 21.8973 12.6607C21.8973 12.2458 21.7522 11.8952 21.462 11.609C21.1716 11.3226 20.819 11.1793 20.4043 11.1793C19.9894 11.1793 19.6389 11.3246 19.3527 11.615C19.0662 11.9054 18.923 12.258 18.923 12.6727C18.923 13.0876 19.0682 13.4381 19.3587 13.7243C19.6489 14.0108 20.0014 14.154 20.4163 14.154ZM11.5957 14.154C12.0106 14.154 12.3611 14.0088 12.6473 13.7183C12.9338 13.4279 13.077 13.0753 13.077 12.6607C13.077 12.2458 12.9318 11.8952 12.6413 11.609C12.3511 11.3226 11.9986 11.1793 11.5837 11.1793C11.169 11.1793 10.8184 11.3246 10.532 11.615C10.2458 11.9054 10.1027 12.258 10.1027 12.6727C10.1027 13.0876 10.2478 13.4381 10.538 13.7243C10.8284 14.0108 11.181 14.154 11.5957 14.154ZM16 22.5127C17.2718 22.5127 18.4431 22.1619 19.514 21.4603C20.5851 20.7586 21.3899 19.8273 21.9283 18.6667H20.6C20.1111 19.4889 19.4611 20.1389 18.65 20.6167C17.8389 21.0944 16.9556 21.3333 16 21.3333C15.0444 21.3333 14.1611 21.0944 13.35 20.6167C12.5389 20.1389 11.8889 19.4889 11.4 18.6667H10.0717C10.6101 19.8273 11.4149 20.7586 12.486 21.4603C13.5569 22.1619 14.7282 22.5127 16 22.5127ZM16.0043 28C14.345 28 12.7849 27.6851 11.324 27.0553C9.86333 26.4256 8.59267 25.5709 7.512 24.4913C6.43133 23.4118 5.57589 22.1422 4.94567 20.6827C4.31522 19.2233 4 17.6639 4 16.0043C4 14.345 4.31489 12.7849 4.94467 11.324C5.57444 9.86333 6.42911 8.59267 7.50867 7.512C8.58822 6.43133 9.85778 5.57589 11.3173 4.94567C12.7767 4.31522 14.3361 4 15.9957 4C17.655 4 19.2151 4.31489 20.676 4.94467C22.1367 5.57445 23.4073 6.42911 24.488 7.50867C25.5687 8.58822 26.4241 9.85778 27.0543 11.3173C27.6848 12.7767 28 14.3361 28 15.9957C28 17.655 27.6851 19.2151 27.0553 20.676C26.4256 22.1367 25.5709 23.4073 24.4913 24.488C23.4118 25.5687 22.1422 26.4241 20.6827 27.0543C19.2233 27.6848 17.6639 28 16.0043 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 13.0222 25.6333 10.5 23.5667 8.43333C21.5 6.36667 18.9778 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16C5.33333 18.9778 6.36667 21.5 8.43333 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z",
    fill: "#879CA9"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarIcon);
export default __webpack_public_path__ + "static/media/user-avatar-icon.1834e0687f5e674d8a240c7decfa6f41.svg";
export { ForwardRef as ReactComponent };